export default __webpack_public_path__ + "styles/WildcardEditor.1fb9929b2495d54e5574731b84d83ff5.css";